import { useState, useEffect } from 'react';
// Importamos el servicio que acabas de crear en el paso anterior
import { obtenerMapaConfiguraciones } from '../../../services/Configuracion/ConfiguracionCabService';

// ESTE ES EL CÓDIGO PADRE DE TU MÓDULO EN BASE DE DATOS.
// Según tus archivos anteriores, parece ser 'NOM-0000' para Nómina.
// Si en tu BD usas otro (ej: 'NOM'), cámbialo aquí.
const CODIGO_MODULO_NOMINA = 'NOM-0000'; 

export const useNominaConfig = () => {
    const [configMap, setConfigMap] = useState({});
    const [loadingConfig, setLoadingConfig] = useState(true);
    const [errorConfig, setErrorConfig] = useState(null);

    
    useEffect(() => {
        let isMounted = true;

        const cargarConfiguracion = async () => {
            try {
                setLoadingConfig(true);

                // 1. Pedimos el diccionario al Backend
                const mapa = await obtenerMapaConfiguraciones(CODIGO_MODULO_NOMINA);
                
                if (isMounted) {
                    // Validación básica: Si el mapa viene vacío, avisamos para depurar la BD
                    if (!mapa || Object.keys(mapa).length === 0) {
                        console.warn(`[useNominaConfig] El mapa llegó vacío. Verifique que el código padre '${CODIGO_MODULO_NOMINA}' sea correcto y que la columna 'parametro' en 'configuracion_cab' tenga datos.`);
                    } else {
                        console.log("Configuración cargada exitosamente:", mapa);
                    }
                    
                    setConfigMap(mapa);
                }
            } catch (err) {
                console.error("Error fatal cargando configuración:", err);
                if (isMounted) setErrorConfig(err);
            } finally {
                if (isMounted) setLoadingConfig(false);
            }
        };

        cargarConfiguracion();

        return () => { isMounted = false; };
    }, []);

    // Retornamos todo lo necesario para quien use este hook
    return { configMap, loadingConfig, errorConfig };
};